
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';

export default Vue.extend({
  name: 'SemiDonutChart',
  props: {
    infoDisk: {
      type: Number,
      required: true,
    }
  },
  components: {
    apexchart: VueApexCharts,
  },

  data: () => ({
    series: [0],
    labels: ['0% Utilizado'],
  }),

  watch: {
    infoDisk: {
      immediate: true,
      handler(newVal: number) {
        this.series = [newVal];
        this.labels = [`${newVal}% ${this.$t('misc.usedPercentage')}`];
      }
    }
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'radialBar',
          offsetY: -20,
          sparkline: {
            enabled: true,
          },
        },
        colors: ['#2196f3'],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: '#e7e7e7',
              strokeWidth: '97%',
              margin: 5,
              dropShadow: {
                enabled: true,
                top: 2,
                color: '#999',
                opacity: 0.5,
                blur: 2,
              },
            },
            hollow: {
              margin: 10,
              size: '70%',
            },
            dataLabels: {
              name: {
                show: true,
              },
              value: {
                show: false,
                fontSize: '20px',
                formatter: (val: number) => `${val}%`,
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        labels: this.labels,
        theme: {
          mode: !this.$vuetify?.theme?.dark ? 'light' : 'dark',
        },
      };
    },
  },
});
